import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';

export default class ModalSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            array: props.array,
            data: [
                {dist: 'até 1km', key: "1.00", selected: false},
                {dist: 'até 2km', key: "2.00", selected: false},
                {dist: 'até 3km', key: "3.00", selected: false},
                {dist: 'até 4km', key: "4.00", selected: false},
                {dist: 'até 5km', key: "5.00", selected: false},
                {dist: 'até 6km', key: "6.00", selected: false},
                {dist: 'até 7km', key: "7.00", selected: false},
                {dist: 'até 8km', key: "8.00", selected: false},
                {dist: 'até 9km', key: "9.00", selected: false},
                {dist: 'até 10km', key: "10.00", selected: false},
                {dist: 'até 11km', key: "11.00", selected: false},
                {dist: 'até 12km', key: "12.00", selected: false},
                {dist: 'até 13km', key: "13.00", selected: false},
                {dist: 'até 14km', key: "14.00", selected: false},
                {dist: 'até 15km', key: "15.00", selected: false},
                {dist: 'até 16km', key: "16.00", selected: false},
                {dist: 'até 17km', key: "17.00", selected: false},
                {dist: 'até 18km', key: "18.00", selected: false},
                {dist: 'até 19km', key: "19.00", selected: false},
                {dist: 'até 20km', key: "20.00", selected: false},
            ]
        }
    }

    // componentDidMount() {
    //     var str1 = "00:45",
    //     str2 = "00:30";

    //     if (str1 <= str2)
    //         alert("menor ou igual");
    //     else
    //         alert("Time 2 is later than time 1");
    // }

    check() {
        let {data, array} = this.state;
        for (let i = 0; i < array.length; i++) {
            for (let j = 0; j < data.length; j++) {
                if (array[i].distancia === data[j].key) {
                    data[j].selected = true
                }
            }
        }
        this.setState({data});
    }

    componentDidMount() {
        this.check();
    }

    render() {
        return (
            <Container>
                <div className="default">
                    <div className="close">
                        <button 
                            onClick={() => this.props.closeModal()}>
                            <IoMdClose color="#fff" className="i-close" />
                        </button>
                    </div>
                    <label>
                        Escolha uma distância
                    </label>
                </div>
                { this.state.data.map(item => { 

                    // let vals = item;
                    
                    // this.filter(item.key);
                    
                    return (
                    <div key={item.key}
                        onClick={() => !item.selected ? this.props.selecionar(this.state.id, item.key) : null}
                        className={!item.selected ? 'horario-disponivel' : 'horario-indisponivel'}>
                        <label className="disponivel">
                            {item.dist}
                        </label>
                    </div>
                )}) }
            </Container>
        )
    }
}